import styled from 'styled-components';
import BodyText from '../../elements/BodyText';
import AdSenseUnit from '../../elements/AdSenseUnit';
var ArticleList = styled.div.withConfig({
  displayName: "GhostArticlesstyles__ArticleList",
  componentId: "pantheon__sc-3vqpo2-0"
})(["margin-top:3rem;display:flex;background-color:", ";flex-wrap:wrap;padding:0;overflow:hidden;"], function (props) {
  var _props$colors;

  return ((_props$colors = props.colors) == null ? void 0 : _props$colors.background) || "transparent";
});
var ArticlesContainer = styled.div.withConfig({
  displayName: "GhostArticlesstyles__ArticlesContainer",
  componentId: "pantheon__sc-3vqpo2-1"
})(["width:85%;background-color:", ";margin:0 auto;position:relative;padding-top:1rem;@media only screen and (max-width:576px){width:", ";}"], function (props) {
  var _props$colors2;

  return ((_props$colors2 = props.colors) == null ? void 0 : _props$colors2.background) || "transparent";
}, function (props) {
  var _props$colors3;

  return ((_props$colors3 = props.colors) == null ? void 0 : _props$colors3.featuredbg) ? "94%" : "100%";
});
var ViewMore = styled(BodyText).withConfig({
  displayName: "GhostArticlesstyles__ViewMore",
  componentId: "pantheon__sc-3vqpo2-2"
})(["text-align:center;text-decoration:none;font-weight:700;cursor:pointer;margin-top:20px;color:", ";font-family:", ";", ";"], function (props) {
  var _props$colors4;

  return ((_props$colors4 = props.colors) == null ? void 0 : _props$colors4.viewmore) || "black";
}, function (props) {
  var _props$fonts;

  return ((_props$fonts = props.fonts) == null ? void 0 : _props$fonts.body) || "Arial";
}, function (props) {
  var _props$theme;

  return (_props$theme = props.theme) == null ? void 0 : _props$theme.ghostViewMore;
});
var DefaultAdsenseBanner = styled(AdSenseUnit).withConfig({
  displayName: "GhostArticlesstyles__DefaultAdsenseBanner",
  componentId: "pantheon__sc-3vqpo2-3"
})(["width:100%;display:block;height:90px;width:", ";text-align:", ";margin:0 auto 2.5rem;@media only screen and (max-width:768px){width:728px;height:90px;}@media only screen and (max-width:576px){width:320px;margin:0 auto 1rem auto;height:100px;}"], function (props) {
  return props.middleAd ? "100%" : "970px";
}, function (props) {
  return props.middleAd ? "center" : "";
});
export { ArticleList, ArticlesContainer, ViewMore, DefaultAdsenseBanner };